import HomeContainer from "../../HomeContainer/HomeContainer";
import AppSwiper from "../../../common/AppSwiper";
import { SwiperSlide } from "swiper/react";

import "./BrandsSkeleton.css";

export default function BrandsSkeleton({ count = 8 }) {
  return (
    <HomeContainer>
      <section className="home-brands brands-skeleton">
        <AppSwiper
          spaceBetween={10}
          navigation={false}
          breakpoints={{
            0: {
              slidesPerView: 2.2,
            },

            576: {
              slidesPerView: 3.2,
            },

            768: {
              slidesPerView: 4.2,
            },

            992: {
              slidesPerView: 7.2,
            },

            1200: {
              slidesPerView: 8,
            },
          }}
        >
          {Array.from({ length: count }).map((_, index) => (
            <SwiperSlide key={index}>
              <div className="brand-card-skeleton">
                <div className="brand-card-skeleton__image" />

                <div className="brand-card-skeleton__title" />
              </div>
            </SwiperSlide>
          ))}
        </AppSwiper>
      </section>
    </HomeContainer>
  );
}